import React, { useRef, useState, useEffect, useLayoutEffect } from "react"
import '../landing.css';
import {  Link, useHistory} from "react-router-dom";

import { firestore } from "../firebase/firebase";

import SignInModal from '../signin';
import SignUpModal from '../signup';

import PlansButton from "../paymentLanding";

import { AppBar, Toolbar, Button, Divider, IconButton, AccordionDetails, Typography, Grid, CardMedia, Card, CardContent, Box} from "@mui/material";

import { makeStyles } from '@material-ui/core/styles';
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import TextField from "@material-ui/core/TextField";
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import cloud from "../cloud.svg"
import logo from "../logo.png"
import { Avatar } from '@material-ui/core';

import imageOne from "../imageOne.svg"
import imageTwo from "../imageTwo.svg"

import Crowd from "../../components/Crowd.mp4"

import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

import { useAuth } from "../firebase/AuthContext";

import Password from "../forgotPassword";

import translate from "./images/2/translate.gif"
import Cognitive from "./images/2/cognitive.gif"
import english from "./images/2/english.gif"
import hard from "./images/2/hard.gif"
import words from "./images/2/words.gif"
import day from "./images/2/day.gif"
import different from "./images/2/different.gif"
import test from "./images/2/test.gif"


const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  rounded: {
    borderRadius: "10px",
    border: "none",
  },
  container: {
    backgroundColor: "#F9FAFB",
    padding: "8%",
  },
  image: {
    width: "100%",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
  },
  title: {
    fontFamily: "Inter",
    fontSize: "35px",
    fontWeight: "bold",
  },
  subtitle: {
    fontFamily: "Inter",
    color: "#6B7280",
    fontSize: "18px",
  },
  
}));


const posts = [{
  id: 1,
  title: 'What does dyslexia do to a person?',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is a common learning disability that affects reading and writing abilities. Individuals with dyslexia often struggle with phonological processing, which makes it difficult to connect sounds and letters together. However, dyslexia can also have additional effects beyond reading and writing difficulties, such as trouble with word retrieval, following directions, and organizing thoughts. In particular, individuals with dyslexia may have difficulty communicating and explaining their ideas. In this blog post, we will explore the different types of dyslexia, common symptoms, causes, and treatments. We will also discuss how dyslexia can impact communication and provide strategies for coping and developing strong communication skills.',
  url: '/What-does-dyslexia-do-to-a-person'
},
{
  id: 2,
  title: 'How does dyslexia affect thinking?',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is a common learning disability that affects millions of people worldwide. It is a complex disorder that can affect various aspects of learning, including reading, writing, and math. Dyslexia can also impact an individuals social and emotional well-being, making it crucial to understand how it affects thinking. In this article, we will explore the cognitive, reading, writing, and math difficulties associated with dyslexia, and how they impact learning and everyday life. We will also discuss the importance of early detection and evidence-based interventions for managing dyslexia. By the end of this guide, you will have a better understanding of how dyslexia affects thinking and the strategies for overcoming its challenges.',
  url: '/How-does-dyslexia-affect-thinking'
},
{
  id: 3,
  title: 'The Benefits of Dyslexia: Why its time to change the narrative',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is often portrayed as a learning disability or a hindrance, but what if we told you that it is actually an advantage? That iss right, dyslexia comes with many benefits that are often overlooked due to the negative stigma surrounding it.',
  url: '/Benefits-of-dyslexia'
},
{
  id: 4,
  title: 'How Does Dyslexia Affect Communication? Understanding the Impact of Dyslexia on Communication Skills',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is a common learning disorder that affects language processing and comprehension. It is estimated that up to 15% of the population may have dyslexia, with varying degrees of severity. While dyslexia is most commonly associated with difficulties in reading and writing, it can also have a significant impact on communication skills.',
  url: '/How-does-dyslexia-affect-communication'
},
{
  id: 5,
  title: 'What is a Thinking Framework?',
  datePublished: '17/03/2023',
  summary: 'Every day, we face a multitude of decisions, both big and small, that can have a significant impact on our lives. From choosing what to eat for breakfast to deciding on a career path, the choices we make can shape our future in profound ways. However, making the right decision is not always easy, and can often be overwhelming, especially when dealing with complex issues. This is where a thinking framework comes in.',
  url: '/What-is-a-thinking-framework'
},
{
  id: 6,
  title: 'Does dyslexia affect verbal comprehension?',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is a common learning disorder that affects the ability to read, write, and spell. People with dyslexia may struggle with phonemic awareness, decoding, and word recognition, which can impact their academic performance and everyday life. However, dyslexia is not just limited to reading and writing; it can also affect other areas of learning, such as verbal comprehension. Verbal comprehension is the ability to understand and process spoken language, which is crucial for communication, learning, and social interactions. In this blog post, we will explore the relationship between dyslexia and verbal comprehension. We will examine the challenges that people with dyslexia face in understanding spoken language and discuss strategies to improve their verbal comprehension skills. Understanding this relationship can help educators, parents, and individuals with dyslexia to better navigate and overcome the challenges associated with dyslexia.',
  url: '/Does-dyslexia-affect-verbal-comprehension'
},
{
  id: 7,
  title: 'Understanding Communication Challenges for Neurodivergent Individuals',
  datePublished: '17/03/2023',
  summary: 'Neurodiversity refers to the range of differences in brain function and behavior that exist among individuals. This concept recognizes that neurological differences are a natural part of human variation, and that individuals with conditions such as autism, ADHD, dyslexia, Tourette syndrome, schizophrenia, and bipolar disorder have unique strengths and challenges that should be acknowledged and celebrated. One of the most significant challenges faced by neurodivergent individuals is communication.',
  url: '/Understanding-communication-challenges-for-neurodivergent-individuals'
},
{
  id: 8,
  title: 'Navigating Relationships as a Neurodivergent Individual',
  datePublished: '17/03/2023',
  summary: 'Neurodivergent individuals, including those with autism, ADHD, and other neurological conditions, often face unique challenges when it comes to relationships. Navigating social cues, communication, and emotional regulation can be particularly difficult for these individuals, which can put a strain on their romantic, platonic, and familial relationships. However, understanding how neurodivergence affects relationships and developing strategies to navigate these challenges can help foster stronger connections between neurodivergent individuals and their loved ones. In this blog, we will explore the challenges faced by neurodivergent individuals in relationships and discuss strategies for navigating those challenges. We will also highlight the unique strengths and perspectives that neurodivergent individuals bring to relationships, and why it is important to embrace neurodiversity in all types of relationships.',
  url: '/Navigating-relationships-as-a-neurodivergent-individual'
},
{
  id: 9,
  title: 'Exploring the Connection between Dyslexia and Difficulty with Explanation',
  datePublished: '17/03/2023',
  summary: 'In this blog post, we explore the connection between dyslexia and difficulty with explanation. We delve into the causes and common signs of dyslexia, the impact it has on communication, and strategies to help dyslexic people explain effectively.',
  url: '/Exploring-the-Connection-between-Dyslexia-and-Difficulty-with-Explanation'
},
{
  id: 10,
  title: 'How to Develop an Effective Communication Strategy in Your Personal Life',
  datePublished: '17/03/2023',
  summary: 'Effective communication is a crucial element in our personal lives. Our ability to communicate effectively can impact our relationships, career, and overall well-being. Communication strategies can help individuals achieve their personal goals and maintain healthy relationships with others. In this article, we will explore what communication strategies are and why they are important in personal life. We will also discuss steps to develop an effective communication strategy and best practices to improve our communication skills. By the end of this article, you will have a better understanding of how to implement an effective communication strategy in your personal life.',
  url: '/How-to-Develop-an-Effective-Communication-Strategy-in-Your-Personal-Life'
},
{
  id: 11,
  title: 'Why Framework Thinking is Crucial for Success in Today’s World',
  datePublished: '17/03/2023',
  summary: 'In today’s fast-paced and complex world, having a strategic mindset and framework thinking is more important than ever. Framework thinking can help you make better decisions, solve problems, and achieve your goals more efficiently. In this blog post, we will discuss the importance of framework thinking and how it can benefit you.',
  url: '/Why-Framework-Thinking-is-Crucial-for-Success-in-Today’s-World'
},
{
  id: 12,
  title: 'Understanding Mental Frameworks: What They Are and Why They Matter',
  datePublished: '17/03/2023',
  summary: 'Providing a comprehensive overview of mental frameworks, their types, importance, and ways to identify and challenge them. Mental frameworks refer to the beliefs, biases, and assumptions that shape our thoughts, behaviors, and decision-making processes. The article explains various types of mental frameworks, including cultural, personal, and professional, and how they are formed and evolve. The blog highlights the significance of mental frameworks in personal and professional lives and their impact on societal issues such as diversity and inclusion. The article also provides strategies to identify and challenge mental frameworks, broaden perspectives, and enhance creativity and problem-solving skills. The blog concludes by encouraging readers to reflect on their mental frameworks and take steps to expand their perspectives for personal growth and development.',
  url: '/Understanding-Mental-Frameworks-What-They-Are-and-Why-They-Matter'
},
{
  id: 13,
  title: 'Unlocking the Positive Side of Dyslexia: Why People Say Dyslexia is a Gift',
  datePublished: '17/03/2023',
  summary: 'The post will discuss the positive aspects of dyslexia, challenges that people with dyslexia face, scientific explanations for dyslexia, and examples of successful individuals with dyslexia. The post will begin with an introduction that defines dyslexia and addresses negative stereotypes. It will then explore the benefits of dyslexia in different fields, followed by a scientific explanation for why dyslexia can be considered a gift. The post will also discuss the challenges that come with dyslexia and provide strategies for overcoming them. Finally, the post will summarize the main points and encourage readers to embrace dyslexia as a gift. By following this outline, the blog post will attract readers and optimize for search engines with a catchy title and valuable content.',
  url: '/Why-do-people-say-dyslexia-is-a-gift'
},{
  id: 14,
  title: 'Understanding the Rarity of Dyslexia in the UK',
  datePublished: '17/03/2023',
  summary: 'Dyslexia is a neurodevelopmental disorder that affects reading and writing skills, and it is estimated that 10% of the population in the UK has dyslexia. Despite this relatively high prevalence rate, dyslexia is often misunderstood and its impact on individuals and society is often overlooked. Understanding the rarity of dyslexia in the UK is therefore crucial in order to raise awareness, promote early detection and intervention, and support dyslexic individuals to reach their full potential. In this article, we will provide an overview of dyslexia in the UK, including prevalence rates, causes, and support options. We will also share inspiring success stories of dyslexic individuals who have overcome their challenges and achieved great things. By the end of this article, we hope to shed light on the reality of dyslexia in the UK and inspire readers to take action to support and empower dyslexic individuals.',
  url: '/Understanding-the-Rarity-of-Dyslexia-in-the-UK'
},
{
  id: 15,
  title: '5 Essential Steps for Effective Idea Generation',
  datePublished: '17/03/2023',
  summary: 'Idea generation is a critical aspect of innovation and problem-solving across various fields and industries. Whether you are an entrepreneur looking to develop a new product, a marketer devising a new campaign, or a scientist exploring new avenues of research, generating and implementing ideas is a fundamental process that drives progress and success. However, the process of idea generation can often feel overwhelming or uncertain, especially when faced with complex problems or limited resources. To ensure effective idea generation, it is crucial to follow a structured approach that involves a series of steps that guide the process from identifying the problem or opportunity to refining and implementing the chosen idea. In this article, we will discuss the five essential steps for effective idea generation, providing tips and strategies to help you navigate each stage of the process and increase your chances of success.',
  url: '/5-Essential-Steps-for-Effective-Idea-Generation'
},
{
  id: 16,
  title: 'Effective Communication: How to Discuss Your Ideas with People',
  datePublished: '17/03/2023',
  summary: 'This blog post is all about effective communication when discussing ideas with others. The author provides several tips to prepare for the discussion, establish common ground, use active listening skills, express ideas clearly and concisely, find solutions, and reach a conclusion. The post emphasizes the importance of clear communication and collaboration, and encourages readers to put these tips into practice in their own discussions. SEO keywords include communication, discuss ideas, effective communication, active listening, collaboration, common ground, expressing ideas, solutions, and conclusion.',
  url: '/Effective-Communication-How-to-Discuss-Your-Ideas-with-People'
},
{
  id: 17,
  title: 'Mastering the Art of Communicating Complex Ideas: A Guide',
  datePublished: '17/03/2023',
  summary: 'Communicating complex ideas can be challenging, especially if the audience lacks the required knowledge and expertise to understand the content. However, mastering the art of communicating complex ideas is crucial for individuals in various fields, including academia, business, and research. This blog will provide a comprehensive guide on how to effectively communicate complex ideas. The guide will cover various aspects of effective communication, including understanding your audience, simplifying complex ideas, structuring your message, using language effectively, non-verbal communication, and practicing and receiving feedback. By the end of the blog, readers will be equipped with the necessary tools and techniques to communicate complex ideas with ease and confidence.',
  url: '/Mastering-the-Art-of-Communicating-Complex-Ideas'
},{
  id: 18,
  title: 'Clear Communication: Tips and Strategies for Effective Communication',
  datePublished: '17/03/2023',
  summary: 'Clear communication is essential for building successful relationships, whether in personal or professional settings. However, not everyone possesses strong communication skills, and misunderstandings can easily arise if messages are not conveyed clearly. In this blog post, we will discuss tips and strategies for effective communication, including verbal and nonverbal communication, active listening, and choosing the right communication channel. By following these guidelines, you can improve your communication skills and avoid misunderstandings, thereby strengthening your relationships and achieving your goals.',
  url: '/Clear-Communication-Tips-and-Strategies-for-Effective-Communication'
},{
  id: 19,
  title: 'The Importance of Communication in Interviews: Why It Matters for Job Seekers',
  datePublished: '4/04/2023',
  summary: 'Communication skills are critical for job seekers, especially during interviews. In this blog post, we will explore the importance of effective communication in interviews, its impact on the hiring process, and provide tips for job seekers to improve their communication skills and ace their interviews.',
  url: '/The-Importance-of-Communication-in-Interviews'
},
{
  id: 20,
  title: 'Mastering Classroom Management: Understanding the 3 Cs of Communication',
  datePublished: '6/04/2023',
  summary: 'Effective communication is an essential aspect of classroom management. To achieve success, educators must understand and implement the three Cs of communication: clarity, consistency, and compassion. This blog post delves into the importance of each C, offering strategies to improve communication within the classroom. Additionally, we explore how the 3 Cs work together to create a positive learning environment. Finally, we discuss potential challenges that may arise when implementing these strategies and offer solutions to overcome them. By the end of this article, readers will have a deeper understanding of the 3 Cs and be able to apply them to their own classroom management practices.',
  url: '/Mastering-Classroom-Management-Understanding-the-Cs-of-Communication'
},{
  id: 21,
  title: 'The Importance of Effective Communication: When and Where It Is Essential',
  datePublished: '17/03/2023',
  summary: 'Effective communication is a critical aspect of daily life, both in personal and professional contexts. From sharing information to resolving conflicts, communication helps to build relationships and ensure that everyone is on the same page. However, not all situations require the same level or style of communication. In this blog, we will explore when and where effective communication is essential, from the workplace to personal relationships and beyond.',
  url: '/The-Importance-of-Effective-Communication'
},,{
  id: 22,
  title: 'The Top Reasons Why Communication Breakdowns Occur',
  datePublished: '08/04/2023',
  summary: 'Communication breakdowns can occur in any type of relationship, whether personal or professional. The ability to communicate effectively is crucial in order to convey thoughts, feelings, and information accurately. In this article, we will explore the top reasons why communication breakdowns occur. These include a lack of clarity, emotional barriers, physical barriers, cultural differences, and a lack of active listening. By understanding the reasons for communication breakdowns, individuals can work to improve their communication skills and avoid misunderstandings.',
  url: '/The-Top-Reasons-Why-Communication-Breakdowns-Occur'
},{
  id: 23,
  title: 'The Ultimate Guide to Effective Communication While Working Remotely',
  datePublished: '11/04/2023',
  summary: 'Effective communication is crucial for the success of remote teams. However, remote work comes with its own set of communication challenges that can hinder productivity and teamwork. This blog post provides insights into how to overcome these challenges and offers practical tips and best practices for communicating effectively while working remotely. By implementing the tips and best practices discussed, remote teams can establish a strong communication culture that fosters productivity, trust, and teamwork.',
  url: '/The-Ultimate-Guide-to-Effective-Communication-While-Working-Remotely'
},
]


const BlogOne = () => {
  
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openTwo, setOpenTwo] = useState(false);
  const emailRef2 = useRef();
  const passwordRef2 = useRef();
  const emailRef = useRef()
  const passwordRef = useRef()
  const passwordConfirmRef = useRef()
  const { currentUser, signup, login } = useAuth();
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const [stripeId, setStripeId] = useState("");

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
});


  useEffect(() => {
    if (currentUser && currentUser.uid) { // add a null check before accessing uid
      const unsubscribe = firestore
        .collection("customers")
        .doc(currentUser.uid)
        .onSnapshot((doc) => {
          const data = doc.data();
          setStripeId(data?.stripeId || ""); // set stripeId state
        });
  
      return unsubscribe; // cleanup the listener
    }
  }, [currentUser]);

  
    const handleOpen = () => {
      if(!currentUser){
        setOpen(true);
      }else{
        history.push("/workspace")
      }
    };

    const handleOpenTwo = () => {
      if(!currentUser){
        setOpenTwo(true);
      }else{
        
        const handleCustomerPortalClick = async () => {
          setIsLoading(true);
        
          try {
            const response = await fetch(`${process.env.REACT_APP_PORTAL}/create-portal-link`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                returnUrl: window.location.origin,
                locale: 'auto',
                userId: `${stripeId}`
              }),
            });
        
            const { url } = await response.json();
            window.location.assign(url);
          } catch (error) {
            console.error(error);
          } finally {
            setIsLoading(false);
          }
        };

        handleCustomerPortalClick();

      }
      
    };


    const handleOpenThree = () => {
      if(!currentUser){
        setOpenTwo(true);
      }else{
        history.push("/workspace")
      }
    };




    const SignInButtonModalTwo = () => {

      const handleClose = () => {
        setOpenTwo(false);
      };
    
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
          setError("");
          setLoading(true);
          await login(emailRef2.current.value, passwordRef2.current.value);
          history.push("/workspace")
          handleClose();
        } catch {
          setError("Incorrect email or password.");
        }
    
        setLoading(false);
      };
      
      
      return (
        <div>
        <Modal
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', outline:'none' }}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openTwo}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500
          }}
        >
          <Fade in={openTwo}>
            <div style={{ backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0px 3px 20px rgba(0,0,0,0.1)', padding: '30px', maxWidth: '400px', width: '100%', outline:'none' }}>
            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
  <IconButton onClick={handleClose}>
    <CloseIcon />
  </IconButton>
</div>
                <center>
                  <h2 style={{ fontFamily: "Inter", fontSize: "30px", fontWeight: "bold" }}>Sign In</h2>
                  <h5 style={{ color: "red" }}>{error}</h5>
                  <form style={{ display: "flex", flexDirection: "column", alignItems: "center" }} onSubmit={handleSubmit}>
                    <TextField
                      id="email"
                      label="Email"
                      inputRef={emailRef2}
                      required
                      sx={{
                        "& fieldset": {
                          border: "none",
                        },
                      }}
                      InputProps={{
                        style: {
                          width: "100%",
                          fontFamily: "'inter",
                          fontStyle: "normal",
                          fontWeight: 700,
                          fontSize: "20px",
                          color: `grey`,
                          margin: "20px",
                          textAlign: "center",
                          "&::placeholder": {
                            textAlign: "center",
                          },
                        },
                      }}
                    />
                    <TextField
                      inputRef={passwordRef2}
                      required
                      id="Password"
                      label="Password"
                      type="password"
                      sx={{
                        "& fieldset": {
                          border: "none",
                        },
                      }}
                      InputProps={{
                        style: {
                          width: "100%",
                          fontFamily: "'inter",
                          fontStyle: "normal",
                          fontWeight: 700,
                          fontSize: "20px",
                          color: `grey`,
                          margin: "20px",
                          textAlign: "center",
                          "&::placeholder": {
                            textAlign: "center",
                          },
                        },
                      }}
                    />
                    <Button
                      style={{ backgroundColor: "#7E3AF2", color: "white", fontFamily: "Inter", marginBottom: "10px" }}
                      disabled={loading}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </form>
                  <div style={{ paddingTop: "60px" }}>
                    <Password />
                  </div>
                  <h4 style={{ color: "#7E3AF2", fontFamily: "Inter", margin: "30px", cursor: "pointer" }} onClick={() => { handleClose(); handleOpen(); }}>
                    Need an account?
                  </h4>
                </center>
              </div>
            </Fade>
          </Modal>
        </div>
      );
      
        
      
      };
  
    

  const SignInButtonModal = () => {

  const handleClose = () => {
    setOpen(false);
  };


    async function handleSubmit(e) {
      e.preventDefault()
  
      if (passwordRef.current.value !== passwordConfirmRef.current.value) {

        return setError("Passwords do not match")
        
      } else {

        try {
          setError("")
          setLoading(true)
          await signup(emailRef.current.value, passwordRef.current.value);
          history.push("/workspace")
          handleClose();
        } catch {
          setError("Failed to create an account")
        }

      }
  
      setLoading(false)
    };
  
  
    return (
      <div>
        <Modal
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500
          }}
        >
          <Fade in={open}>
            <div style={{ backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0px 3px 20px rgba(0,0,0,0.1)', padding: '30px', maxWidth: '400px', width: '100%' }}>
            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
  <IconButton onClick={handleClose}>
    <CloseIcon />
  </IconButton>
</div>
              <center>
                <h2 style={{ fontFamily: 'Inter', fontSize: "30px", fontWeight: 'bold' }}>Sign Up</h2>
                {error}
                <form onSubmit={handleSubmit} style={{ textAlign: "center" }}>
                  <TextField
                    inputRef={emailRef}
                    required
                    label="Email"
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                    InputProps={{
                      style: {
                        width: "100%",
                        fontFamily: "'inter",
                        fontStyle: "normal",
                        fontWeight: 700,
                        fontSize: "20px",
                        color: `grey`,
                        margin: "20px",
                        textAlign: "center",
                        "&::placeholder": {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <TextField
                    inputRef={passwordRef}
                    required
                    label="Password"
                    type="password"
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                    InputProps={{
                      style: {
                        width: "100%",
                        fontFamily: "'inter",
                        fontStyle: "normal",
                        fontWeight: 700,
                        fontSize: "20px",
                        color: `grey`,
                        margin: "20px",
                        textAlign: "center",
                        "&::placeholder": {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <TextField
                    inputRef={passwordConfirmRef}
                    required
                    label="Password Confirmation"
                    type="password"
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                    }}
                    InputProps={{
                      style: {
                        width: "100%",
                        fontFamily: "'inter",
                        fontStyle: "normal",
                        fontWeight: 700,
                        fontSize: "20px",
                        color: `grey`,
                        margin: "20px",
                        textAlign: "center",
                        "&::placeholder": {
                          textAlign: "center",
                        },
                      },
                    }}
                  />
                  <Button style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter', margin: '30px' }} type="submit">
                    Submit
                  </Button>
                </form>
                <p>Please note, by signing up you are agreeing to our terms and condiction.</p>
                <h4 style={{ color: '#7E3AF2', fontFamily: 'Inter', margin: '30px', cursor: 'pointer' }} onClick={() => { handleClose(); handleOpenTwo(); }}>
                  Have an account?
                </h4>
              </center>
            </div>
          </Fade>
        </Modal>
      </div>
    ); };

  
    return (
        <>
          <div>
          <AppBar position="static" style={{ backgroundColor: 'white', boxShadow: "none" }}>
      <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Link to='/'><img src={logo} alt="logo" style={{ width: '150px' }} /></Link>
        <div style={{ display: 'flex', gap: '20px' }}>
        <Link style={{textDecoration: 'none'}} to="/">
  <Button style={{ backgroundColor: 'transparent', textDecoration: 'none', color: 'black', border: 'none', outline: 'none', fontFamily: 'Inter', height: '40px', padding: '0 15px' }}>
    Home
  </Button>
</Link>
          <Button onClick={() => handleOpenThree()} style={{ backgroundColor: 'transparent', textDecoration: 'none', color: 'black', border: 'none', outline: 'none', fontFamily: 'Inter', height: '40px', padding: '0 15px' }}>
      Sign In
    </Button>
          <Button onClick={() => handleOpen()} style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter', height: '40px', padding: '0 15px' }}>
            Sign Up
          </Button>
        </div>
      </Toolbar>
    </AppBar>
            {SignInButtonModal()}
            {SignInButtonModalTwo()}
          </div>
          <center style={{backgroundColor: '#F9FAFB', padding:'5%'}} data-aos="fade-up" data-aos-duration="3000">
      <div >
        <h1>Dyslexia Decoded</h1>
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
        <div style={{textAlign:'left'}}>
            <h1 style={{fontFamily: 'Inter'}}>How does dyslexia affect thinking?</h1>
            <p  style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>Dyslexia is a common learning disability that affects millions of people worldwide. It is a complex disorder that can affect various aspects of learning, including reading, writing, and math. Dyslexia can also impact an individual's social and emotional well-being, making it crucial to understand how it affects thinking. In this article, we will explore the cognitive, reading, writing, and math difficulties associated with dyslexia, and how they impact learning and everyday life. We will also discuss the importance of early detection and evidence-based interventions for managing dyslexia. By the end of this guide, you will have a better understanding of how dyslexia affects thinking and the strategies for overcoming its challenges.</p>
<br/><br/>
<center>
<img src={translate} alt="someone yelling translate it for me" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
            <h2>The Cognitive Effects of Dyslexia</h2>
            <p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>The cognitive effects of dyslexia are complex and multifaceted. Researchers have proposed various theories to explain the underlying cognitive deficits that lead to dyslexia. Here are the three most common theories:

<br/><br/><span style={{fontWeight: 'bold'}}>The Phonological Deficit Hypothesis: </span>
The phonological deficit hypothesis suggests that individuals with dyslexia have difficulty processing the sounds of language, particularly in phonological awareness, which is the ability to distinguish and manipulate individual sounds in words. This difficulty in phonological processing can affect their ability to read, write, and spell.

<br/><br/>T<span style={{fontWeight: 'bold'}}>he Magnocellular Deficit Hypothesis: </span>
The magnocellular deficit hypothesis suggests that individuals with dyslexia have a problem with the visual processing of rapidly changing stimuli, such as letters on a page. The magnocellular pathway is a visual processing pathway in the brain that is responsible for processing fast-moving visual stimuli. This deficit can impact reading and spelling abilities.

<br/><br/><span style={{fontWeight: 'bold'}}>The Executive Function Deficit Hypothesis: </span>
The executive function deficit hypothesis suggests that individuals with dyslexia have difficulty with executive functions, which are a set of cognitive processes responsible for planning, organizing, and executing tasks. This deficit can impact their ability to manage time, remember instructions, and follow multi-step directions.

<br/><br/>While each of these theories explains specific cognitive deficits associated with dyslexia, it is important to note that dyslexia is a complex disorder, and individuals with dyslexia can present with a combination of deficits from these theories. In the next sections, we will explore how these cognitive deficits can affect specific aspects of learning, such as language processing, reading, writing, and math.
</p>
<br/><br/>
<center>
<img src={Cognitive} alt="Someone acting clever" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
<h2>Language Processing Difficulties</h2>
<p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
Language processing difficulties are a common characteristic of dyslexia. Individuals with dyslexia may have difficulty processing various aspects of language, including phonology, syntax, and semantics. Here are some of the language processing difficulties associated with dyslexia:

<br/><br/><span style={{fontWeight: 'bold'}}>Difficulty with Phonological Processing:</span>
Individuals with dyslexia may have difficulty distinguishing individual sounds in words, which can make it challenging for them to sound out and recognize written words. They may also have difficulty with rhyming and phonemic awareness, which is the ability to manipulate individual sounds in words.

<br/><br/><span style={{fontWeight: 'bold'}}>Difficulty with Syntax and Grammar: </span>
Individuals with dyslexia may struggle with understanding and using grammatical rules, such as sentence structure and word order. They may also have difficulty with complex sentence structures, making it challenging for them to understand complex texts.

<br/><br/><span style={{fontWeight: 'bold'}}>Difficulty with Semantic Processing: </span>
Individuals with dyslexia may struggle with understanding the meaning of words and sentences, making it challenging for them to comprehend what they read. They may also have difficulty with word retrieval and vocabulary, making it challenging for them to express their ideas in writing and speaking.

<br/><br/>These language processing difficulties can impact various aspects of learning, including reading, writing, and communication. In the next sections, we will explore how these difficulties impact reading, writing, and math, and the strategies for overcoming them.
</p>
<br/><br/>
<center>
<img src={english} alt="Someone who can't speak english" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
<h2>Reading, Writing, and Math Difficulties</h2>
<p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
Dyslexia affects multiple aspects of learning, including reading, writing, and math. Here are some of the difficulties associated with dyslexia in these areas:

<br/><br/><span style={{fontWeight: 'bold'}}>Reading Difficulties: </span>
Individuals with dyslexia may struggle with reading fluency, accuracy, and comprehension. They may have difficulty recognizing and sounding out words, understanding the meaning of words and sentences, and following the structure and flow of written texts.

<br/><br/><span style={{fontWeight: 'bold'}}>Writing Difficulties: </span>
Individuals with dyslexia may struggle with written expression, spelling, and handwriting. They may have difficulty organizing their ideas, spelling words correctly, and expressing their thoughts coherently in writing. Dyslexia can also affect the speed and accuracy of handwriting.

<br/><br/><span style={{fontWeight: 'bold'}}>Math Difficulties: </span>
Individuals with dyslexia may struggle with math calculations, understanding math concepts, and applying math skills to real-world problems. Dyslexia can affect the ability to read and interpret math symbols, memorize math facts, and understand the logic behind math operations.

<br/><br/>It is important to note that dyslexia affects individuals differently, and some individuals may struggle more with one area than others. However, these difficulties can impact academic performance and social-emotional well-being. The good news is that evidence-based interventions, such as structured literacy instruction, can help individuals with dyslexia overcome these challenges and reach their full potential.
</p>
<br/><br/>
<center>
<img src={hard} alt="writing is hard" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
<h2>Dyslexic Communication</h2>
<p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
Dyslexia can also impact communication skills, including oral language and social communication. Here are some of the difficulties associated with dyslexic communication:

<br/><br/><span style={{fontWeight: 'bold'}}>Difficulty with Word Retrieval and Vocabulary: </span>
Individuals with dyslexia may struggle with finding the right words to express their ideas, and may have a limited vocabulary. This can make it challenging for them to communicate effectively and participate in conversations.

<br/><br/><span style={{fontWeight: 'bold'}}>Difficulty with Verbal Fluency: </span>
Verbal fluency refers to the ability to generate words and ideas quickly and easily. Individuals with dyslexia may struggle with verbal fluency, which can make it challenging for them to express their thoughts and ideas in real-time.

<br/><br/><span style={{fontWeight: 'bold'}}>Difficulty with Social Communication: </span>
Social communication involves the ability to interpret social cues, understand nonverbal communication, and engage in social interactions. Individuals with dyslexia may have difficulty with social communication, which can impact their relationships with peers and adults.

<br/><br/><span style={{fontWeight: 'bold'}}>Difficulty with Executive Functioning: </span>
Executive functioning refers to the cognitive processes that enable individuals to plan, organize, and execute tasks. Individuals with dyslexia may struggle with executive functioning, which can impact their ability to initiate and participate in conversations.

These communication difficulties can impact academic and social-emotional well-being. However, speech therapy and social skills training can help individuals with dyslexia improve their communication skills and build confidence in social situations. It is important to address these difficulties early on to promote success in school and in life.
</p>
<br/><br/>
<center>
<img src={words} alt="a trump speak with his saying that he knows words" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
<h2>The Impact of Dyslexia on Learning and Everyday Life</h2>
<p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
Dyslexia can impact various aspects of life, including learning, work, and everyday activities. Here are some of the ways dyslexia can impact individuals:

<br/><br/><span style={{fontWeight: 'bold'}}>Academic Performance: </span>
Dyslexia can impact academic performance, particularly in areas such as reading, writing, and math. This can affect grades, test scores, and overall academic success.

<br/><br/><span style={{fontWeight: 'bold'}}>Self-Esteem and Confidence: </span>
Dyslexia can impact self-esteem and confidence, as individuals may feel frustrated and discouraged by the challenges they face in learning and communication.

<br/><br/><span style={{fontWeight: 'bold'}}>Career Opportunities: </span>
Dyslexia can impact career opportunities, as individuals may struggle with tasks that require reading, writing, or math skills. However, with appropriate accommodations and support, individuals with dyslexia can excel in a variety of fields.

<br/><br/><span style={{fontWeight: 'bold'}}>Daily Activities: </span>
Dyslexia can impact daily activities, such as reading instructions, filling out forms, and writing emails or texts. This can cause stress and frustration, and may require additional time and effort to complete tasks.

<br/><br/>It is important to recognize the impact of dyslexia and provide appropriate support and accommodations to individuals with dyslexia. With early identification and evidence-based interventions, individuals with dyslexia can overcome challenges and achieve their full potential. Additionally, promoting dyslexia awareness and understanding can help reduce stigma and promote inclusion for individuals with dyslexia.
</p>
<br/><br/>
<center>
<img src={day} alt="someone yelling every single day" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
<h2>Diagnosis and Treatment of Dyslexia</h2>
<p style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
Diagnosing dyslexia can involve a variety of assessments and evaluations, including tests of cognitive abilities, reading and writing skills, and language processing. Here are some of the steps involved in diagnosing dyslexia:

<br/><br/><span style={{fontWeight: 'bold'}}>Screening and Referral: </span>
The first step in diagnosing dyslexia is typically a screening to identify individuals who may be at risk for dyslexia. This may involve observations from parents, teachers, or healthcare professionals, and may include tests of cognitive abilities or language processing.

<br/><br/><span style={{fontWeight: 'bold'}}>Comprehensive Assessment: </span>
Individuals who are identified as at risk for dyslexia may undergo a comprehensive assessment to evaluate their reading and writing skills, language processing abilities, and other relevant areas.

<br/><br/><span style={{fontWeight: 'bold'}}>Diagnosis: </span>
A diagnosis of dyslexia is typically made by a qualified professional, such as a psychologist or neuropsychologist, based on the results of the comprehensive assessment and the individual's history and symptoms.

Once a diagnosis of dyslexia is made, evidence-based interventions can help individuals overcome the challenges associated with dyslexia. Here are some common interventions:

<br/><br/><span style={{fontWeight: 'bold'}}>Structured Literacy Instruction: </span>
Structured literacy instruction is an evidence-based intervention that focuses on building foundational reading and writing skills, such as phonemic awareness, phonics, and spelling. This approach is highly structured and individualized to meet the unique needs of each student.

<br/><br/><span style={{fontWeight: 'bold'}}>Assistive Technology: </span>
Assistive technology, such as text-to-speech software or speech recognition software, can help individuals with dyslexia access written materials and communicate more effectively.

<br/><br/><span style={{fontWeight: 'bold'}}>Accommodations and Modifications: </span>
Accommodations and modifications in the classroom, such as extended time on tests, preferential seating, or alternative assessments, can help individuals with dyslexia access the curriculum and demonstrate their knowledge and abilities.

<br/><br/>It is important to note that dyslexia is a lifelong condition, but with appropriate support and interventions, individuals with dyslexia can achieve their goals and succeed in school and in life.
</p>
<br/><br/>
<center>
<img src={test} alt="Mr Bean checking test results" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>
<h2>Overview</h2>
<p  style={{fontFamily: 'Inter', fontSize: 20, lineHeight: 1.3}}>
In conclusion, dyslexia is a complex neurological condition that affects individuals in various ways. It can impact reading, writing, math, language processing, communication, and daily activities. However, with early identification and evidence-based interventions, individuals with dyslexia can overcome challenges and achieve their full potential.

It is important to raise awareness and understanding of dyslexia, to reduce stigma and promote inclusion for individuals with dyslexia. Educators, healthcare professionals, and parents can play a crucial role in identifying and supporting individuals with dyslexia, and in promoting evidence-based interventions and accommodations.

By working together to support individuals with dyslexia, we can help them thrive in school and in life, and build a more inclusive and supportive society for all.
</p>
<br/><br/>
<center>
<img src={different} alt="someone being unique" style={{ width: '100%', maxWidth: '400px', height: 'auto', }} />
</center>
<br/><br/>

          </div>
        </Grid>
        <Grid item xs={12} md={4}>
        <div style={{ position: 'sticky', top: 23, }}>
      <Card style={{ margin: '30px', textAlign:'left' }}>
        <CardContent>
          <h2>Recent Posts</h2>
          {posts.reverse().slice(0, 5).map(post => (
            <div key={post.id}>
              <Link style={{color:'black', textDecoration: 'none'}} to={`${post.url}`}>
                <h4>{post.title}</h4>
              </Link>
              <Divider />
            </div>
          ))}
          <Link to="/blog"><button style={{ fontFamily: 'Inter', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#7E3AF2', color: '#FFFFFF', padding: '32px', borderRadius: '8px', border: 'none', cursor: 'pointer', width:'100%' }}>View other articles</button></Link>
        </CardContent>
      </Card>
    </div>
    
        </Grid>
      </Grid>
    </center>
          {/* CTA*/}
          <div style={{ marginTop: '100px', marginBottom: '100px', backgroundColor: 'white' }} data-aos="fade-up" data-aos-duration="3000">
            <div style={{ display: "flex", flexDirection: "row", textAlign: 'center' }}>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignContent: 'left' }}>
              <h3 style={{ fontFamily: 'Inter', fontSize: "35px", fontWeight: 'bold' }}>Struggling to communicate your thoughts?</h3>
                <h5 style={{ fontFamily: 'Inter', color: '#6B7280' }}>Use our AI assisted thought management framework to help you communicate your ideas or feelings.</h5>
                <button onClick={() => handleOpen()} style={{ fontFamily: 'Inter', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#7E3AF2', color: '#FFFFFF', padding: '16px 32px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}>Start a board</button>
                <video style={{ borderRadius: '10px', maxWidth: '100%', padding:'3%' }} width="640" height="360" controls>
          <source src={Crowd} type="video/mp4" />
        </video>
              </div>
            </div>
          </div>
          <div>
          <center>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ flex: 1 }}>
                <img src={logo} alt="logo" style={{ maxWidth: '10%', minWidth: '15%', padding: '10px' }} />
              </div>
            </div>
            <h4 ><Link style={{textDecoration: 'none'}} to="/">Homepage</Link></h4>
              <p style={{ fontSize: '10px' }}>Copyright ® 2023 All rights Reserved.
              </p>
            </center>
          </div>
        </>
      );
  
}

export default BlogOne;
